import React, { useEffect } from "react";
import "./faqs.scss";
import OverlayLoading from "../../../common/OverlayLoader/Overlayloader";
import { TitleHeader } from "../../../components";
import { useSelector } from "react-redux";
import { Autocomplete, TextField } from "@mui/material";
import useFaqsUtils from "./faqsUtils";
import { FiTrash, FiX, FiAlertTriangle } from "react-icons/fi";
import { ConfirmationModal } from "../../../common/ConfirmationModal/ConfirmationModal";
import { useState } from "react";

const Faqs = () => {
  const { langauges } = useSelector((state) => state.userAuth);
  const breadcrumbs = [
    { label: "Pages", link: "" },
    { label: "Add Page", link: "" },
  ];

  const {
    loading,
    submitForm,
    faqs,
    handleFAQChange,
    addFAQ,
    removeFAQ,
    language_id,
    setLanguageId,
  } = useFaqsUtils();

  const [showModal, setShowModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    itemToDelete: null,
    title: "",
    description: "",
    warningNote: "",
    confirmText: "",
  });

  // Configure and show the delete modal
  const showDeleteModal = (index, type = "faq") => {
    let config = {
      itemToDelete: index,
      title: "Confirm Deletion",
      description: "Are you sure you want to delete this FAQ?",
      warningNote:
        "This action cannot be undone and the FAQ will be permanently removed.",
      confirmText: "Delete FAQ",
    };

    if (type === "answer") {
      config = {
        itemToDelete: index,
        title: "Clear Answer",
        description: "Are you sure you want to clear this answer?",
        warningNote: "This will remove all content in the answer field.",
        confirmText: "Clear Answer",
      };
    }

    setModalConfig(config);
    setShowModal(true);
  };

  const handleConfirm = () => {
    if (modalConfig.itemToDelete !== null) {
      if (modalConfig.title === "Clear Answer") {
        handleFAQChange(modalConfig.itemToDelete, "answer", "");
      } else {
        removeFAQ(modalConfig.itemToDelete);
      }
    }
    setShowModal(false);
  };

  return (
    <>
      <TitleHeader heading="Faqs" breadcrumbs={breadcrumbs} />

      <ConfirmationModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleConfirm}
        title={modalConfig.title}
        description={modalConfig.description}
        warningNote={modalConfig.warningNote}
        confirmButtonText={modalConfig.confirmText}
      />

      <div className="form-all-grid">
        <div className="form-data-main">
          <div className="form-all-grid">
            <div className="input-main-data">
              <label htmlFor="">Languages</label>
              <Autocomplete
                fullWidth
                className="automcomplete_select_info"
                autoComplete={false}
                id="free-solo-demo"
                options={langauges}
                getOptionLabel={(option) => option?.title}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Language" />
                )}
                value={
                  (langauges &&
                    langauges.find((type) => type.id == language_id)) ||
                  null
                }
                onChange={(e, value) => {
                  setLanguageId(value?.id);
                }}
              />
            </div>
             <div className="input-main-data"></div>
             <div className="input-main-data"></div>
          </div>
        </div>

        <form onSubmit={submitForm}>
          <div className="page-card-bg data-page-big-height">
            <OverlayLoading isLoading={loading}>
              <div className="faq-section">
                {faqs.map((faq, index) => (
                  
                  <div key={index} className="faq-item">
                    <div className="faq-header">
                      <h4>FAQ {index + 1}</h4>
                      <button
                        type="button"
                        className="remove-faq"
                        onClick={() => showDeleteModal(index)}
                      >
                        <FiTrash />
                      </button>
                    </div>

                    <div className="input-main-data mb-4">
                      <label>Question</label>
                      <input
                        type="text"
                        required
                        value={faq.question}
                        onChange={(e) =>
                          handleFAQChange(index, "question", e.target.value)
                        }
                        placeholder="Enter your question here"
                      />
                    </div>

                    <div className="input-main-data">
                      <div className="answer-header">
                        <label>Answer</label>
                      </div>
                      <textarea
                        value={faq.answer}
                        required
                        onChange={(e) =>
                          handleFAQChange(index, "answer", e.target.value)
                        }
                        placeholder="Provide the answer here"
                        rows={4}
                      />
                    </div>
                  </div>
                ))}

                <button type="button" className="add-faq" onClick={addFAQ}>
                  + Add New FAQ
                </button>
              </div>

              {/* Submit button */}
              <div className="btn-form-send">
                <button className="common-button" type="submit">
                  Submit
                </button>
              </div>
            </OverlayLoading>
          </div>
        </form>
      </div>
    </>
  );
};

export default Faqs;
